/**=========================================================
 * Module: ai.js
 * AI Controller
 =========================================================*/

 App.controller('AiController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'DataService', 'LocalRestangular',
     function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, D, LR) {
         "use strict";


         let unwatch = $rootScope.$watch('user.id', function(){  
             if($rootScope.user.id){
                 unwatch();
                 $scope.page = {
                     title: 'AI',
                     subTitle: '' 
                 }

                 if($state.params.action=='qc'){
                    $scope.page.subTitle = 'QC'
                 }

                 FIREBASE.read(['ai','files'], function(response){
                    $scope.processes = response
                 }, null, { keepOnListening: true })

                 $scope.newProcessForm = {
                        title: '',
                        status: '',
                        type: 'ai',
                        model: { },
                        fields: [
                            {
                                available: true,
                                name: 'name',
                                type: 'text',
                                required: true,
                                placeholder: 'Nome univoco del processo, es. nome del file'
                            },
                            {
                                available: true,
                                type: 'submit'
                            }
                        ],
                        submit: function(){
                            $scope.newProcessForm.status = 'submitting'
                            D.call('ai', 'post', 'process', $scope.newProcessForm.model, function(response){
                                $scope.newProcessForm.status = 'submitted'
                                $scope.newProcessForm.message = response.message
                                $scope.newProcessForm.model = { }
                                $scope.newProcessForm.title = ''
                                $scope.newProcessForm.fields[0].value = ''
                            })
                        }
                 }

                 $scope.form = {
                    title: 'Carica un nuovo file',
                    status: '',
                    type: 'ai',
                    model: { id: new Date().getTime() },
                    fields: [
                        {
                            available: true,
                            name: 'upload',
                            type: 'file',
                            label: 'File',
                            limit: 1,
                            canUpload: true,
                            allow: 'mqxlz',
                            bucket: ''
                        }
                    ],
                    submit: function(){
                        $scope.form.status = 'submitting'
                        D.call('ai', 'post', '', $scope.form.model, function(response){
                            $scope.form.status = 'submitted'
                            $scope.form.message = response.message
                            $scope.form.model = { id: new Date().getTime() }
                        })
                    }
                }
             }

         })
     }
 ]);